import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UserService} from "../../services/user/user.service";
import {CompanyService} from "../../services/company/company.service";
import {Company} from "../../models/company";
import Swal from "sweetalert2";

@Component({
  selector: 'app-reset-password-email',
  templateUrl: './reset-password-email.component.html',
  styleUrls: ['./reset-password-email.component.scss']
})
export class ResetPasswordEmailComponent implements OnInit {

  email: string | undefined;
  OTP: string | undefined;
  firstPassword: string = '';
  confirmPassword: string = '';
  showFirstPassword = false;
  showConfirmPassword = false;
  company: Company | null = null;
  loadingCompany = true;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public userService: UserService,
    private companyService: CompanyService,
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.email = this.route.snapshot.params['email'];

    if (!this.email) this.router.navigate(['/login']);

    try {
      this.company = await this.companyService.getCompanyFromDomain(window.location.hostname) ?? null;
    } catch (e) {
      console.error('Reset password company lookup error:', e);
    } finally {
      this.loadingCompany = false;
    }
  }

  get isCompanyBranded(): boolean {
    return !!this.company?.id;
  }

  get brandingLogo(): string {
    return this.company?.logoUrl || 'assets/logo.svg';
  }

  get welcomeTitle(): string {
    return this.isCompanyBranded ? 'Benvenuto' : 'Benvenuto su Well Done';
  }

  get welcomeSubtitle(): string {
    if (this.isCompanyBranded && this.company?.name) {
      return `Completa il recupero password per ${this.company.name}`;
    }
    return 'Completa la procedura di recupero password';
  }

  async sendResetPassword() {
    let response = await this.userService.resetPassword(this.email!, this.confirmPassword!, this.OTP!);

    if (response.success) {
      Swal.fire({
        icon: 'success',
        title: 'Password resettata! Adesso puoi accedere nuovamente'
      })
      this.router.navigate(['/login']);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Errore, il codice otp inserito non è corretto, riprova'
      })
    }
  }

  passwordsAreEquals(){
    if (this.firstPassword.length === 0 || this.confirmPassword.length === 0) return false;
    return ( this.firstPassword.trim() === this.confirmPassword.trim() );
  }
}
